function countAnimation() {
  $('.js-counter').each(function () {
    var $this = $(this);

    jQuery({ Counter: 0 }).animate(
      { Counter: $this.attr('data-count') },
      {
        duration: 2000,
        easing: 'swing',
        step: function (now) {
          $this.text(Math.ceil(now));
        },
      }
    );
  });
}

$(function () {
  var run = 0;

  $('.project-counter-single-content-wrapper').waypoint({
    handler: function (direction) {
      if (run == 0) {
        setTimeout(function () {
          countAnimation();
        }, 500);
        run++;
      }
    },
    offset: '100%',
    offset: 'bottom-in-view',
  });
});
